import {types} from './types';

const setGetCreditHistoryAction = (payload) => {
    return {
        type: types.SET_LIST_CREDIT_HISTORY,
        payload,
      }
}

const setGetCreditLimitsAction = (payload) => {
  return {
      type: types.SET_LIST_CREDIT,
      payload,
    }
}

const setGetListGroupsAction = (payload) => {
return {
    type: types.SET_LIST_GROUPS,
    payload,
  }
}


const setGetCreditLiveAction = (payload) => {
return {
    type: types.SET_CREDIT_LIVE,
    payload,
  }
}

export {
  setGetCreditHistoryAction,
  setGetCreditLimitsAction,
  setGetListGroupsAction,
  setGetCreditLiveAction

}
